





























import Vue from 'vue';
import format from 'date-fns/format';
import min from 'date-fns/min';
import { defineComponent, ref, watch, Ref, onMounted } from '@vue/composition-api';
import { LabelValue } from '../../abstractions';
import mobiscroll from '../../mobiscroll/js/scroller.javascript';

const componentName = 'wok-mobile-picker-month-day';

export default defineComponent({
    name: componentName,

    props: {
        value: {
            type: String,
            default: '01-01'
        },
        pickerLabel: {
            type: String,
            default: ''
        },
        cancelLabel: {
            type: String,
            default: 'Cancel'
        },
        confirmLabel: {
            type: String,
            default: 'Confirm'
        },
        locale: {
            default: undefined
        }
    },

    setup(props, context) {
        const scroller = ref() as Ref<HTMLDivElement>;
        const confirmDisabled = ref(false);

        function formatMonth(month: number) {
            return format(new Date(today.getFullYear(), month-1), "MMMM", { locale: props.locale });
        }

        function parseValue(value: string | null) {
            if (value) {
                var parts = value.split('-');
                return [parseInt(parts[1]), formatMonth(parseInt(parts[0]))];
            }
            return [1, formatMonth(1)];
        }

        const days = new Array<number>(), months = new Array<string>(), today = new Date();
        const disabledDaysPerMonth = [[], [30,31], [], [31], [], [31], [], [], [31], [], [31], []];

        for (let i = 1 ; i <= 31 ; i++) {
            days.push(i);
        }
        for (let i = 1 ; i <= 12 ; i++) {
            months.push(formatMonth(i));
        }

        let lastSelectedValue = props.value;
        let scrollerInstance: any = null;

        onMounted(() => {
            scrollerInstance = (<any>mobiscroll).scroller(scroller.value, {
                display: 'inline',
                showLabel: false,
                wheels: [
                    [{
                        circular: false,
                        data: days
                    }, {
                        circular: false,
                        data: months
                    }]
                ],
                formatValue: function (data: [number, string]) {
                    let month = months.findIndex(x => x == data[1]) + 1;
                    return month.toString().padStart(2, '0') + '-' + data[0].toString().padStart(2, '0');
                },
                parseValue: function (valueText: string) {
                    return parseValue(valueText);
                },
                validate: function(evt: any) {
                    let monthIndex = months.findIndex(x => x == evt.values[1]);
                    confirmDisabled.value = disabledDaysPerMonth[monthIndex].includes(evt.values[0]);

                    // if (evt.index == 0) {
                    //     return {
                    //         disabled: [
                    //             [], months.filter((x, i) => disabledDaysPerMonth[i].includes(evt.values))
                    //         ]
                    //     }
                    // }
                    // if (evt.index == 1) {
                    //     return {
                    //         disabled: [
                    //             disabledDaysPerMonth[monthIndex], []
                    //         ]
                    //     }
                    // }
                },
                onChange: (evt: { valueText: string }) => {
                    lastSelectedValue = evt.valueText;
                }
            });
            scrollerInstance.setVal(parseValue(props.value));
        });

        watch(() => props.value, value => {
            scrollerInstance?.setVal(parseValue(value));
        });

        const onConfirm = () => {
            context.emit('input', lastSelectedValue);
        }

        const onRequestHidePicker = () => {
            context.emit('hide-picker');
        }

        return {
            scroller,
            confirmDisabled,
            onConfirm,
            onRequestHidePicker
        }
    }
})
